import { $themeBreakpoints } from '@themeConfig'

export default {
  namespaced: true,
  state: {
    windowWidth: 0,
    shallShowOverlay: false,
    notifications: [],
    cartAddress: {
      first_name: '',
      last_name: '',
      address: '',
      address_2: '',
      post_code: '',
      city: '',
      country: '',
      is_company: false,
      company_name: '',
      nip: '',
    },
    customLayoutMenu: [],
    currentCourse: {},
    courseId: null,
    course: null,
  },
  getters: {
    getCourseId: state => {
      return state.courseId;
    },
    currentBreakPoint: state => {
      const { windowWidth } = state
      if (windowWidth >= $themeBreakpoints.xl) return 'xl'
      if (windowWidth >= $themeBreakpoints.lg) return 'lg'
      if (windowWidth >= $themeBreakpoints.md) return 'md'
      if (windowWidth >= $themeBreakpoints.sm) return 'sm'
      return 'xs'
    },
    getNotifications: state => state.notifications,
    getCartAddress: state => state.cartAddress,
    getCustomMenuLayout: state => state.customLayoutMenu,
    getCurrentCourse: state => state.currentCourse,
    getCourse: state => state.course,
  },
  mutations: {
    UPDATE_COURSE_ID(state, val) {
      state.courseId = val;
    },
    UPDATE_WINDOW_WIDTH(state, val) {
      state.windowWidth = val
    },
    TOGGLE_OVERLAY(state, val) {
      state.shallShowOverlay = val !== undefined ? val : !state.shallShowOverlay
    },
    UPDATE_CART_ADDRESS(state, address) {
      state.cartAddress = address
    },
    UPDATE_CUSTOM_LAYOUT_MENU(state, menu) {
      state.customLayoutMenu = menu
    },
    UPDATE_CURRENT_COURSE(state, course) {
      state.currentCourse = course
    },
    UPDATE_COURSE(state, course) {
      state.course = course
    },
  },
  actions: {
  },
}
